import { FC } from "react";
import { IconPropsType } from ".";

export const DownloadPdf: FC<IconPropsType> = (props) => {
  return (
    <svg
      width={props.size ?? 18}
      height={props.size ?? 18}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.633 2C20.3813 2 20.9878 2.60658 20.9878 3.35484V8.05778L23.1607 5.74004C23.6725 5.19416 24.5299 5.1665 25.0758 5.67826C25.6216 6.19002 25.6493 7.04742 25.1375 7.5933L20.6214 12.4105C20.3653 12.6837 20.0075 12.8387 19.633 12.8387C19.2585 12.8387 18.9007 12.6837 18.6446 12.4105L14.1285 7.5933C13.6167 7.04742 13.6444 6.19002 14.1902 5.67826C14.7361 5.1665 15.5935 5.19416 16.1053 5.74004L18.2782 8.05778V3.35484C18.2782 2.60658 18.8847 2 19.633 2Z"
        fill={props.color ?? "#555555"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.43945 10.5806C7.43945 8.33587 9.2592 6.51613 11.504 6.51613C12.2522 6.51613 12.8588 7.12271 12.8588 7.87097C12.8588 8.61922 12.2522 9.22581 11.504 9.22581C10.7557 9.22581 10.1491 9.83239 10.1491 10.5806V25.0323C10.1491 26.2794 11.1601 27.2903 12.4072 27.2903H21.4395C22.6865 27.2903 23.6975 26.2794 23.6975 25.0323V12.3871C23.6975 11.6388 24.3041 11.0323 25.0524 11.0323C25.8006 11.0323 26.4072 11.6388 26.4072 12.3871V25.0323C26.4072 27.7759 24.1831 30 21.4395 30H12.4072C9.66359 30 7.43945 27.7759 7.43945 25.0323V10.5806Z"
        fill={props.color ?? "#555555"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9556 16.9032C11.9556 16.155 12.5622 15.5484 13.3104 15.5484H20.5362C21.2845 15.5484 21.8911 16.155 21.8911 16.9032C21.8911 17.6515 21.2845 18.2581 20.5362 18.2581H13.3104C12.5622 18.2581 11.9556 17.6515 11.9556 16.9032Z"
        fill={props.color ?? "#555555"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.762 22.3226C13.762 21.5743 14.3686 20.9677 15.1169 20.9677H18.7298C19.478 20.9677 20.0846 21.5743 20.0846 22.3226C20.0846 23.0708 19.478 23.6774 18.7298 23.6774H15.1169C14.3686 23.6774 13.762 23.0708 13.762 22.3226Z"
        fill={props.color ?? "#555555"}
      />
    </svg>
  );
};
